import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import Axios from 'axios';

interface FileObject {
  endpoint: string;
  fileName: string;
  uuid: string;
  key: string;
}

export const AttachmentList = (props: any) => {
  // Track which attachment (by key) is currently downloading so we can show a spinner.
  const [downloadingKey, setDownloadingKey] = React.useState<string | null>(null);

  const handleDownload = async (item: FileObject) => {
    const url = `${(window as any)._env_.REACT_APP_SERVER}/request/getAttachment/${item.key}`;
    setDownloadingKey(item.key);
    try {
      const res = await Axios.get(url, { responseType: 'blob' });

      // The backend may respond 200 with an error body (JSON) if something
      // slips through; guard against an empty/zero-length download too.
      if (!res.data || res.data.size === 0) {
        throw new Error('Empty file received.');
      }

      const blobUrl = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = decodeURIComponent(item.fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err: any) {
      let message = 'Could not download the attachment. Please try again.';
      if (err?.response?.status === 404) {
        message = 'This attachment no longer exists on the server.';
      }
      alert(`Error downloading "${decodeURIComponent(item.fileName)}": ${message}`);
      console.log('Error: /frontend/src/components/RequestForms/components/AttachmentList//handleDownload', err);
    } finally {
      setDownloadingKey(null);
    }
  };

  let fileStrings = String(props.files).split(';');
  fileStrings.splice(3, 1);

  let fileObjects: FileObject[] = [];
  fileStrings.forEach((item) => {
    let slashSplit = item.split('/');
    let endpoint = slashSplit[0] + '//' + slashSplit[1] + '/';
    let keyFileNameSplit = String(slashSplit[3]).split('_--_');
    let fileName = keyFileNameSplit[0];
    // console.log('frontend key: ', fileName)
    let uuid = keyFileNameSplit[1];
    let key = slashSplit[3];
    fileObjects.push({ endpoint, fileName, uuid, key });
  });

  return (
    <div className='col-sm-8'>
      <div className='form-group'>
        <label className='mr-2'>Attachments</label>
        {fileObjects.map((item, value) => {
          if (item.fileName === undefined || item.fileName === 'undefined') return null;
          const isDownloading = downloadingKey === item.key;
          return (
            <Button key={item.key || value} variant='info' className='mr-2' disabled={isDownloading} onClick={() => handleDownload(item)}>
              {isDownloading && <Spinner className='mr-1' as='span' animation='border' size='sm' role='status' aria-hidden='true' />}
              {decodeURIComponent(item.fileName)} {<i className='fa fa-download' />}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
